module.exports = __webpack_public_path__ + "static/media/id-popup-step4.7ae50341.png";